import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import Button from '../../../components/buttons/Button';
import { hasPermission } from '../../../utils/HelperFunctions';
import OrdersTableContainer from '../../../modules/orders/components/OrdersTableContainer';

const Orders = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle, searchEle } = useModuleTableHelpers({
    route: 'admin/orders',
    withBreadcrumb: true,
    withSearch: true,
    breadcrumbTitle: t('links.orders'),
    withPagination: true,
    queryKey: 'orders',
    customSearchPlaceholder: `${t("search_by")} ${t("chassis")}, ${t("email")}, ${t("phone")} ${t("or")} ${t("username")}`
  });

  const tableHeaders = [
    { label: t('id') },
    { label: t('model') },
    { label: t('chassis') },
    { label: t('user') },
    { label: t('amount') },
    { label: t('date') },
    { label: t('status') },
    hasPermission(['orders.edit']) && { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading && !apiData) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="orders-page-container">
      <ListHeader customClass='table_filters'>
        <div className="filter_container">{searchEle}</div>
        {hasPermission(['leeds.confirm_lead_vehicle_order']) && <Button text={t("new_order")} link="/orders/create-order" />}
      </ListHeader>
      <OrdersTableContainer tableHeaders={tableHeaders} data={apiData} apiDataLoading={apiDataLoading} noDataMessage={t('no_orders_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default Orders;
